import { render } from "./StudentCard.vue?vue&type=template&id=7d8041a6&scoped=true"
import script from "./StudentCard.vue?vue&type=script&lang=js"
export * from "./StudentCard.vue?vue&type=script&lang=js"

import "./StudentCard.vue?vue&type=style&index=0&id=7d8041a6&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8041a6"]])

export default __exports__